import API from '../../sunwiseAPI';
const ENTITY = 'measurement-source';

export const create = (data) => API.post(`/api/v1/${ENTITY}/sunpay/`, data);
export const getItems = (uuid) => API.get(`/api/v1/${ENTITY}/${uuid}/sunpay/`);
export const update = (uuid, data) =>
    API.put(`/api/v1/${ENTITY}/${uuid}/sunpay`, data);
export const deleteItem = (uuid) =>
    API.delete(`/api/v1/${ENTITY}/${uuid}/sunpay/`);
